import { render, staticRenderFns } from "./KoalaPayFailed.vue?vue&type=template&id=130f062b&"
import script from "./KoalaPayFailed.vue?vue&type=script&lang=js&"
export * from "./KoalaPayFailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports